import React, { useEffect } from 'react';
import { motion, useAnimate } from 'framer-motion';

const IconHeart = ({ active = false, stroke = 'white', fill = 'white', shadowOnActive = true }) => {
  const [scope, animate] = useAnimate();

  useEffect(() => {
    if (active) {
      animate(
        [
          ['path', { pathLength: 0 }, { duration: 0 }],
          ['path', { pathLength: 1.1 }, { duration: 0.5 }],
          ['path', { fillOpacity: 1 }, { duration: 0.2 }],
          [
            scope.current,
            {
              scale: [1, 1.15, 0.95, 1],
              y: [0, -10, 2, 0],
            },
            { duration: 0.4, type: 'spring', stiffness: 120, damping: 13, mass: 0.8 },
          ],
        ],
        {
          ease: 'easeInOut',
        }
      );
    } else {
      animate([['path', { fillOpacity: 0 }, { duration: 0.4 }]], {
        ease: 'easeInOut',
      });
    }
  }, [active]);

  return (
    <svg
      width={20}
      height={17}
      viewBox="0 0 20 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        filter: shadowOnActive && active ? 'drop-shadow(0px 0px 6px rgb(0 0 0 / 0.4))' : 'none',
        width: 20,
        height: 17,
      }}
      ref={scope}
    >
      <motion.path
        d="M11.8135 2.26758C12.9342 1.13918 14.2247 0.760094 15.7344 1.14648L16.0391 1.2334C17.5503 1.71267 18.425 2.75571 18.8379 4.29785H18.8389C18.9138 4.57668 18.9344 4.80514 19 5.20117V5.82129C18.9921 5.86168 18.9801 5.92129 18.9746 5.98926C18.9138 6.72932 18.6698 7.43412 18.2686 8.125L18.2676 8.12598C17.7468 9.02686 17.0418 9.82284 16.2227 10.6025C14.2634 12.466 12.1502 14.0932 10.0059 15.8857C9.99518 15.8769 9.98407 15.8678 9.97266 15.8584C9.84064 15.7491 9.66151 15.6004 9.44727 15.4219C9.0189 15.065 8.45117 14.5894 7.83594 14.0732C6.60332 13.0391 5.18846 11.8451 4.33301 11.1025C3.30295 10.2088 2.41586 9.27228 1.79004 8.18848H1.78906C0.768947 6.42469 0.72475 4.71925 1.73047 2.97852C2.25418 2.0822 3.05278 1.47479 4.12695 1.17969C5.29843 0.862263 6.35885 0.980208 7.35645 1.58398L7.3584 1.58594C7.99526 1.96897 8.49971 2.50912 8.94336 3.18262L8.94727 3.18945C9.02939 3.3121 9.05229 3.35346 9.1416 3.49023L9.8916 4.64062L10.7559 3.57227C11.2157 3.0038 11.4402 2.64187 11.8125 2.26758H11.8135Z"
        stroke={stroke}
        strokeWidth={2}
        fill={fill}
        initial={{ fillOpacity: 0, pathLength: 1.1 }}
      />
    </svg>
  );
};

export default IconHeart;
